import React, { Component } from 'react';
import { getOwnerContract }  from '../../services/contract';
import getTokenContract from '../../services/tokenContract'
import { ethers } from 'ethers';
import levelPrices from '../../services/levelPrice';
import getWallet from '../../services/wallet';
import withWrapper from '../../helpers/withWrapper';

class Rewards extends Component {

    state = {
    };

    async componentDidMount() {
      // window.googleTranslateElementInit = () => {
      //   new window.google.translate.TranslateElement(
      //     { pageLanguage: 'en' },
      //     'google_translate_element'
      //   );
      // };
  
      // // Add the script tag to the HTML document
      // const script = document.createElement('script');
      // script.src = 'http://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      // script.defer = true;
      // document.body.appendChild(script);

    }

    addToMetamask = async () => {
        try {
            // wasAdded is a boolean. Like any RPC method, an error may be thrown.
            const wasAdded = await window.ethereum.request({
              method: 'wallet_watchAsset',
              params: {
                type: 'ERC20', // Initially only supports ERC20, but eventually more!
                options: {
                  address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F', // The address that the token is at.
                  // address: '0xD6bdfA86136F8390C8513d27C2578fE7e54C89d8', // The address that the token is at.
                  symbol: 'USDT', // A ticker symbol or shorthand, up to 5 chars.
                  decimals: 6, // The number of decimals in the token
                    //   image: tokenImage, // A string url of the token logo
                },
              },
            });
          
            if (wasAdded) {
              console.log('Thanks for your interest!');
            } else {
              console.log('Your loss!');
            }
          } catch (error) {
            console.log(error);
          }
    }

    addBUSOToMetamask = async () => {
      try {
          // wasAdded is a boolean. Like any RPC method, an error may be thrown.
          const wasAdded = await window.ethereum.request({
            method: 'wallet_watchAsset',
            params: {
              type: 'ERC20', // Initially only supports ERC20, but eventually more!
              options: {
                address: '0x7E26081D41fD9a18a32b66268C8cC5c621eb1cF2', // The address that the token is at.
                // address: '0x7b89E846a430F0E4C220E0a7caf2D4dA0D6a777f', // The address that the token is at.
                symbol: 'BUSO', // A ticker symbol or shorthand, up to 5 chars.
                decimals: 6, // The number of decimals in the token
                  //   image: tokenImage, // A string url of the token logo
              },
            },
          });
        
          if (wasAdded) {
            console.log('Thanks for your interest!');
          } else {
            console.log('Your loss!');
          }
        } catch (error) {
          console.log(error);
        }
    }

    render() { 
        return (
            <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
                    <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
                        {/* Top Panel, Matrix levels and all activies inside below div */}
                        <div className="flex flex-col w-full space-y-10 sm:space-y-5">
                            <div className="text-lg sm:text-md">
                            <span style={{ color: "#ffff00" }}>Coming Soon: </span> {/* <a href='https://ip2025.biz' target="_blank">Click to Buy</a> */}                             </div>
                           {/* <div className="text-lg sm:text-md">
                            <span style={{ color: "#00ffff" }}>50 USDT for 30 Accounts in Class 5 (IP Together): </span>
                            </div>
                            {/* <div className="text-lg sm:text-md">
                            <span style={{ color: "#ffc107" }}>Burning Record: </span>
                            </div>        
                            <div className="text-lg sm:text-md">
                            <span style={{ color: "#ff0000" }}>1st Burning: </span> <a href='https://polygonscan.com/tx/0x2e848fdd936fb6a3f2ab116e96aa459874d9df98644845361dd7cf4964c15013' target="_blank">1,000,000 IP</a>
                            </div>                                               */}
                        </div>
                    </div>
            </div>
        );
    }
}
 
export default withWrapper(Rewards);